import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger, SplitText);

export function initHeroStatements() {
    const container = document.querySelector('.content__statements');
    if (!container) return;

    const statements = Array.prototype.slice.call(container.querySelectorAll('.statement'));
    if (!statements.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reduced motion / single statement
    if (statements.length === 1 || prefersReducedMotion) {
        gsap.set(statements, { autoAlpha: 0 });
        gsap.set(statements[0], { autoAlpha: 1 });
        return;
    }

    const splits = [];

    statements.forEach(function (statement) {
        const p = statement.querySelector('p');
        if (!p) return;

        const split = new SplitText(p, {
            type: 'words,chars'
        });

        splits.push(split);

        gsap.set(statement, { autoAlpha: 0 });
        gsap.set(split.chars, { autoAlpha: 0 });
    });

    const tl = gsap.timeline({
        repeat: -1
    });

    statements.forEach(function (statement, i) {
        const split = splits[i];
        if (!split) return;

        const charCount = split.chars.length;
        const duration = Math.max(1, charCount * 0.04);

        tl.set(statement, { autoAlpha: 1 })
            .to(split.chars, {
                autoAlpha: 1,
                ease: 'none',
                duration: duration,
                stagger: duration / charCount
            })
            .to({}, { duration: 1.5 })
            .to(statement, {
                autoAlpha: 0,
                duration: 0.4
            })
            .set(split.chars, { autoAlpha: 0 });
    });
}

export function initHeroShapes() {
    const banner = document.querySelector('.banner--prop');
    const bgShapes = document.querySelector('[data-shapes]');

    if (!banner || !bgShapes) {
        return;
    }

    const bgShape = gsap.timeline();

    bgShape.to('.bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2,
        stagger: 0.3
    });
    bgShape.call(updateShapes);

    bgShape.to('.bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });

    const shapes = document.querySelectorAll('.shape-path');
    const shapesMorph = gsap.timeline({
        repeat: -1,
        yoyo: true,
        onRepeat: updateShapes
    });

    let colors = [];

    if (bgShapes.dataset.shapes === 'multicolour') {
        colors = ['#FF7BBF', '#FAF161', '#71DEF2', '#C4A3FF', '#00D1A6'];
    } else {
        colors = ['#ffffff'];
    }

    let previousShapes = new Array(shapes.length).fill(null);
    let previousColors = new Array(shapes.length).fill(null);

    function updateShapes() {
        // Shuffle the shapes array before starting the loop
        const shuffledShapes = [...shapes].sort(() => Math.random() - 0.5);

        shuffledShapes.forEach(function (shape, index) {
            let newShape;
            do {
                newShape = gsap.utils.random([
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 15, 16
                    //14,10,11 don't work well
                ]);
            } while (newShape === previousShapes[index]);

            previousShapes[index] = newShape;

            let newColor;
            do {
                newColor = gsap.utils.random([0, 1, 2, 3, 4]);
            } while (newColor === previousColors[index]);

            previousColors[index] = newColor;

            shapesMorph.to(
                shape,
                {
                    morphSVG: {
                        shape: '#shape' + newShape,
                        map: 'complexity',
                        type: 'linear'
                    },
                    fill: colors[newColor],
                    duration: 2,
                    ease: 'elastic.inOut',
                    stagger: index * 0.5
                },
                '>-0.5'
            );
        });
    }
}

export function initHeroScroll() {
    const banner = document.querySelector('.banner--prop');

    if (!banner) return;

    gsap.to('.banner--prop__content', {
        opacity: 0,
        y: -100,
        scrollTrigger: {
            trigger: '.banner--prop',
            start: 'clamp(top 130px)',
            scrub: 2
        }
    });

    gsap.utils.toArray('.bg-shape__wrapper').forEach((shape) => {
        gsap.to(shape, {
            y: -gsap.utils.random(50, 300),
            opacity: 0,
            scrollTrigger: {
                trigger: '.banner--prop',
                start: 'clamp(top 130px)',
                end: 'bottom top',
                scrub: 2
            }
        });
    });
}
